import { Stack } from "@mantine/core"
import { Radio, radioCardClasses } from "@tfg/ui"

import { useVerifyCompanyOutcomeOptions } from "~/pages/SupplierPortal/Onboarding/hooks/useVerifyCompanyOutcomeOptions"
import type { VerifyCompanyOutcome } from "~/pages/SupplierPortal/Onboarding/verifyCompanyOutcome/verifyCompanyOutcome.types"

type VerifyCompanyOutcomeRadioGroupProps = Readonly<{
  "aria-labelledby": string
  selectedOutcome: VerifyCompanyOutcome
  onSelectOutcome: (outcome: VerifyCompanyOutcome) => void
}>

export const VerifyCompanyOutcomeRadioGroup = ({
  "aria-labelledby": ariaLabelledBy,
  selectedOutcome,
  onSelectOutcome,
}: VerifyCompanyOutcomeRadioGroupProps) => {
  const options = useVerifyCompanyOutcomeOptions()

  return (
    <Radio.Group
      aria-labelledby={ariaLabelledBy}
      onChange={(value) => {
        if (value.length > 0) {
          onSelectOutcome(value as VerifyCompanyOutcome)
        }
      }}
      style={{ overflow: "visible" }}
      value={selectedOutcome}
    >
      <Stack
        className={radioCardClasses.list}
        gap="var(--tfg-molecule-padding-y)"
        pt="xs"
      >
        {options.map(({ outcome, label, description }) => (
          <Radio.Card
            key={outcome}
            description={description}
            label={label}
            value={outcome}
          />
        ))}
      </Stack>
    </Radio.Group>
  )
}
